// src/components/RedirectPage.js

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RedirectPage = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const targetUrl = params.get('target');

    // --- DEBUGGING LINE ---
    console.log("Redirecting to:", targetUrl);

    if (targetUrl) {
      try {
        // This is a more robust way to handle the redirect
        window.location.replace(targetUrl);
      } catch (error) {
        console.error("Redirect failed:", error);
      }
    } else {
        console.error("No target URL found for redirect.");
    }
  }, [location]);

  return (
    <div style={{ padding: '50px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h2>Redirecting...</h2>
      <p>Please wait while we take you to the requested page.</p>
    </div>
  );
};

export default RedirectPage;